import axios from "axios"
import { getToken } from "./token"
console.log()
const http = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? '/api' : process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 5000 // request timeout
})

// request interceptor
http.interceptors.request.use(
  config => {
    config.headers['token'] = getToken()
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
http.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code === 200 ){
      return res
    } else if( res.code === 401 || res.code === 400 ){
      location.replace('/login')
    } else {
      // console.log(res)
      return Promise.reject(res)
    }
  },
  error => {
    // console.log('err' + error) // for debug
    // Toast({message: '123'})
    return Promise.reject(error)
  }
)

export default http
